/*
 * @Descripttion:
 * @Author: zhanghang
 * @Date: 2023-03-31 17:08:38
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-09-26 15:25:30
 */
import graphEvent from "./graphEvent.js";
import dataAndGraphRelationMixin from "./dataAndGraphRelationMixin.js";
import dynamicCharts from "./dynamicCharts.js";
import styleOptions from "./styleOptions.js";
import lineAddMarkLine from "./lineAddMarkLine.js";
import { chartCommon } from "_dataview/output/utils/commonEvent.js";
export default {
  mixins: [
    graphEvent,
    dataAndGraphRelationMixin,
    dynamicCharts,
    styleOptions,
    lineAddMarkLine,
  ],
  props: {
    //风格对应组件key
    styleMapKey: {
      type: String,
      default: "dataviewGraph",
    },
    //chart对象 字符串形式
    chartString: {
      type: String,
      default: "",
    },
    //循环时间
    cycleTime: {
      type: String,
      default: "-1",
    },
    //默认高亮项
    defaultHighLight: {
      type: Number,
      default: 8,
    },
    //部分图表滚动条
    dataZoom: {
      type: Boolean,
      default: false,
    },
    dataZoomInfo: {
      type: Object,
      default: () => ({
        backgroundColor: "#003062",
        fillerColor: "#018BFF",
        handleColor: "#cecece",
        width: "auto",
        height: "8",
        top: "auto",
        right: "20",
        left: "5",
        bottom: "12",
      }),
    },
    dataZoomNumber: {
      type: Number,
      default: 8,
    },
    dataZoomStart: {
      type: Boolean,
      default: false,
    },
    dataZoomCustom: {
      type: Boolean,
      default: false,
    },
    splitName: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    includeEvents() {
      let commonEvents = Object.keys(chartCommon);
      return [...commonEvents, ...this.otherEvents];
    },
    dataZoomOption() {
      let options = {
        type: "slider",
        show: true,
        textStyle: {
          color: "#DCF0FF",
        },
        orient: "horizontal",
        left: "5",
        xAxisIndex: [0],
        borderColor: "none",
        fillerColor: "#018BFF",
        backgroundColor: "#003062",
        height: 8,
        handleIcon:
          "M512 512m-208 0a6.5 6.5 0 1 0 416 0 6.5 6.5 0 1 0-416 0Z M512 192C335.264 192 192 335.264 192 512c0 176.736 143.264 320 320 320s320-143.264 320-320C832 335.264 688.736 192 512 192zM512 800c-159.072 0-288-128.928-288-288 0-159.072 128.928-288 288-288s288 128.928 288 288C800 671.072 671.072 800 512 800z",
        handleColor: "#cecece",
        handleSize: 15,
        handleStyle: {
          borderColor: "#cecece",
        },
        showDetail: false,
        brushSelect: false,
        bottom: 12,
      };
      return {
        ...options,
        ...this.dataZoomInfo,
      };
    },
  },
  watch: {
    dataZoomCustom() {
      this.$nextTick(() => {
        if (this.isDesign) {
          this.reset();
        }
      });
    },
    dataZoomStart() {
      this.$nextTick(() => {
        if (this.isDesign) {
          this.reset();
        }
      });
    },
    dataZoomNumber() {
      this.$nextTick(() => {
        if (this.isDesign) {
          this.reset();
        }
      });
    },
    dataZoomOption() {
      this.$nextTick(() => {
        if (this.isDesign) {
          this.reset();
        }
      });
    },
    dataZoom: {
      handler(v) {
        if (this.chart) {
          this.reset();
        }
      },
    },
    splitName() {
      if (this.isDesign) {
        this.reset();
      }
    },
    cycleTime() {
      this.resetCallback();
    },
  },
  data() {
    return {
      isOldChatExcelFlag: true, // 用于图表是否是老版本的图表
      // 图表对象
      chartObj: null,
      timer: null,
      // 组件类型
      componentType: "chart",

      otherEvents: [],
    };
  },
  created() {
    // chartstring 获取 chartstring 作为chart
    if (this.chartString) {
      let chartString = this.chartString;
      let tmp = `(function () {
        return ${chartString}
      })()`;

      let chart = eval(tmp);
      for (let key in this.chart) {
        Reflect.deleteProperty(this.chart, key);
      }
      Object.assign(this.chart, chart);
      this.$emit("update:chart", chart);
    }
    this.judgeIsOldChatExcel();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.chartObj && this.chartObj.dispose?.();
  },
  methods: {
    judgeIsOldChatExcel() {
      this.isOldChatExcelFlag =  dsf.dataview.utils.judgeIsOldChatExcel(
        this.excelData,
        this.chartType
      );
    },
    changeGraph(attributes) {
      dsf.layer.confirm("是否切换图表类型？").then(() => {
        attributes.customType = "graph";
        //获取动态的数据来源
        let {
          combineTable,
          dataSource,
          dataType,
          dataURL,
          mapFieldList,
          datasourceMapFieldList,
          configAttachRequestParams,
          combineTableParams,
          dataSourceParams,
        } = this;
        let comp = attributes.data;
        //数据源保留
        if (comp) {
          let content = JSON.parse(comp.content);

          content.combineTable = combineTable;
          content.dataSource = dataSource;
          content.dataURL = dataURL;
          content.dataType = dataType;
          content.mapFieldList = mapFieldList;
          content.datasourceMapFieldList = datasourceMapFieldList;
          content.configAttachRequestParams = configAttachRequestParams;
          content.combineTableParams = combineTableParams;
          content.dataSourceParams = dataSourceParams;
          comp.content = JSON.stringify(content);
        }

        this.$designer.changeSelectComp(attributes, null, () => {
          this.$nextTick(() => {
            $(
              ".ds-designer-property.property-item[rel='chart'] .ds-button"
            )[0]?.click();
          });
        });
      });
    },
    //excel 数据处理
    dealExcelData() { },
    //标准数据解析-excel数据方式
    standardDataAnalysis() { },
    caculateDataZoom(chart = this.chart) {
      // 配置总览自定义不走删除dataZoom逻辑
      if (this.dataZoomCustom) {
        return;
      }
      //开启的
      if (this.dataZoom) {
        let xAxis = chart.xAxis[0];
        let yAxis = chart.yAxis[0];

        let dataZoom = this.dataZoomOption;
        let dataZoomW = dataZoom.width;
        let dataZoomH = dataZoom.height;
        if (xAxis.type === "category") {
          let category = xAxis;
          let categoryLength = category.data.length;
          dataZoom.xAxisIndex = [0];
          Reflect.deleteProperty(dataZoom, "yAxisIndex");
          // x轴类目轴
          if (this.dataZoomNumber < categoryLength) {
            const startIdx = this.dataZoomStart
              ? 0
              : categoryLength - this.dataZoomNumber;
            const endIdx = this.dataZoomStart
              ? this.dataZoomNumber - 1
              : categoryLength - 1;
            dataZoom.startValue = category.data[startIdx];
            dataZoom.endValue = category.data[endIdx];
            dataZoom.orient = "horizontal";
            dataZoom.width = dataZoomW;
            dataZoom.height = dataZoomH;
            chart.dataZoom = dataZoom;
          } else {
            Reflect.deleteProperty(chart, "dataZoom");
          }
        } else if (yAxis.type === "category") {
          let category = yAxis;
          let categoryLength = category.data.length;
          dataZoom.yAxisIndex = [0];
          Reflect.deleteProperty(dataZoom, "xAxisIndex");
          // y轴类目轴
          if (this.dataZoomNumber < categoryLength) {
            const startIdx = this.dataZoomStart
              ? 0
              : categoryLength - this.dataZoomNumber;
            const endIdx = this.dataZoomStart
              ? this.dataZoomNumber - 1
              : categoryLength - 1;
            dataZoom.startValue = category.data[startIdx];
            dataZoom.endValue = category.data[endIdx];
            dataZoom.orient = "vertical";
            dataZoom.width = dataZoomH;
            dataZoom.height = dataZoomW;
            chart.dataZoom = dataZoom;
          } else {
            Reflect.deleteProperty(chart, "dataZoom");
          }
        } else {
          Reflect.deleteProperty(chart, "dataZoom");
        }
      } else {
        Reflect.deleteProperty(chart, "dataZoom");
      }
    },
    transPX(size) {
      if (dsf.isNumber(size) || /^\d+$/g.test(size)) {
        size += "px";
      }
      return size;
    },
    beforeInit() {
      this.loadCharts(this)
        .then(() => {
          this.init();
        })
        .catch((ex) => {
          dsf.error(ex);
        });
    },
    loadCharts() {
      return this.loadEcharts(this)
        .then(() => {
          this.initEacharts()
        })
        .catch((ex) => {
          throw ex;
        });
    },
    initEacharts() {
      let echarts = window.$echarts || window.echarts;
      this.chartObj = echarts.init(this.$refs["chart"]);
    },
    loadEcharts(tag) {
      return new Promise((resolve, reject) => {
        if (!window.echarts && !window.$echarts) {
          /****观察者模式动态加载echarts script 标签，防止多次加载script   start******************/
          dsf.emit.$on("loadCharts", () => {
            window.$echarts = window.echarts;
            //加载完成
            resolve();
          }, tag);
          if (!window.echartsLoad) {
            window.echartsLoad = true;
            dsf.http
              .importFiles([dsf.url.getWebPath('$/js/libs/echarts/echarts.min.5.4.3.js')])
              .then(() => {
                dsf.emit.$emit('loadCharts');
              })
              .catch((err) => {
                dsf.layer.message('加载echarts文件报错', false)
                reject(err);
              });
          }
          return;
        }
        //加载完成
        resolve();
      })
    },
    //过滤属性
    filterChartData(chart) {
      if (!this.isDesign) return false
      let keys = ["dataZoom", "timeline", "options"];
      keys.forEach((key) => {
        Reflect.deleteProperty(chart, key);
      });
      // 地图构造数据图层删除
      if (chart.geo) {
        chart.series = chart.series.filter((it) => !it.seriesLayer);
      }
    },
    reset() {
      if (!this.chartObj || !this.chart) return false;

      this.chartObj && this.chartObj.hideLoading();
      let series = this.chart.series;
      let hasData = false;

      if (series && series.length) {
        for (let i = 0; i < series.length; i++) {
          let it = series[i];
          let data = it.data;
          if (data.length > 0) {
            hasData = true;
            break;
          }
        }
      }
      this.$set(this, "hasData", hasData);

      // 额外的钩子函数
      this.extraCallBack(this.chart, this);

      // 下面三个存在先后顺序，勿动
      this.addMarkLineToLine();
      this.caculateTimeline();
      this.splitCategroy();
      this.caculateDataZoom();
      if (this.chartObj) {
        this.chartObj.clear();
        this.chartObj.setOption(this.chart, true);
        this.filterChartData(this.chart);
      }

      setTimeout(this.resetCallback, 500);
    },
    //类目轴名称分割
    splitCategroy() { },
    //事件添加
    resetCallback() {
      let chart = this.chartObj;

      let series = this.chart.series;
      if (!series || series.length === 0) {
        return false;
      }

      // 当前索引
      let curInd = 0;
      const len = series[0].data.length;

      let highSeries = [0];
      clearInterval(this.timer);
      if (this.cycleTime > 0 && len) {
        /*建立时间监听器*/
        this.timer = setInterval(function () {
          chart.dispatchAction({
            type: "downplay",
            seriesIndex: highSeries,
          });
          chart.dispatchAction({
            type: "hideTip",
            seriesIndex: highSeries,
          });
          curInd++;
          if (curInd === len) {
            curInd = 0;
          }
          chart.dispatchAction({
            type: "highlight",
            seriesIndex: highSeries,
            dataIndex: curInd,
          });
          chart.dispatchAction({
            type: "showTip",
            seriesIndex: highSeries,
            dataIndex: curInd,
          });
        }, this.cycleTime);
      }

      try {
        chart.off("click");
      } catch (error) {
        console.log(error);
      }
      chart.on("click", (params) => {
        if (this.$listeners["chart-click"]) {
          this.$dispatch("chart-click", params);
        }
        this.loadClickEvents(params);
      });
    },
    $resize() {
      this.chartObj && this.chartObj.resize();
    },
    // 额外的钩子函数, 组件在执行操作时,需要对charts做单属于组件的charts操作
    extraCallBack() { },
    resize() {
      this.$resize();
    },
  },
};
